import { ChangeDetectorRef, Directive, HostBinding, Inject, LOCALE_ID, Optional } from '@angular/core';
import { LANGUAGE_CODE } from '../interfaces/TranslationsMap';
import { DATE_TIMEZONE_OVERRIDE } from '../../forms/interfaces/Tokens';

/* tslint:disable:directive-selector */
@Directive({
    selector: 'anj-locale:not([manual])',
})
export class LocaleDirective {
    @HostBinding('attr.locale') _locale: string;
    @HostBinding('attr.lang') _lang: string;
    @HostBinding('attr.timezone') _timezone: string;

    constructor(
        private changeRef: ChangeDetectorRef,
        @Optional() @Inject(LOCALE_ID) _locale?: string,
        @Optional() @Inject(LANGUAGE_CODE) _lang?: string,
        @Optional() @Inject(DATE_TIMEZONE_OVERRIDE) _timezone?: string
        ) {

        if (_locale) {
            this._locale = _locale;
            this._lang = _lang ? _lang : this._locale ? this._locale.split('-')[0] : 'en';
        }

        if (_timezone) {
            this._timezone = _timezone;
        }

        this.changeRef.markForCheck();
    }
}
